import { BellAlertIcon } from '@heroicons/react/24/outline';

import { Link } from '@/components/ui/link';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardWhiteLabelNbTicketsProps = {
  className?: string;
};

export function CardWhiteLabelNbTickets({
  className,
}: CardWhiteLabelNbTicketsProps) {
  return (
    <StatsBox
      className={className}
      icon={{ color: 'primary', element: <BellAlertIcon /> }}
      title="Open SMA tickets"
      value="3"
    >
      <StatsBox.Action>
        <Link to="/">View Tickets</Link>
      </StatsBox.Action>
    </StatsBox>
  );
}
